/**
 * LangServer 모듈 업로드 API
 */
import { langServerClient } from '@/shared/api/langserver/client';

import type { ModuleTarget, UploadModuleResponse } from './types';

export const uploadModule = async (
  target: ModuleTarget,
  clientId: string,
  file: File
): Promise<UploadModuleResponse> => {
  let lastError: unknown;

  for (let attempt = 0; attempt < 3; attempt++) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await langServerClient.post<UploadModuleResponse>(
        `/${target}/api/v1/modules/${clientId}/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      return response.data;
    } catch (error) {
      lastError = error;
      if (attempt < 2) {
        await new Promise((resolve) => setTimeout(resolve, 300 * (attempt + 1)));
      }
    }
  }

  console.error('Failed to upload module:', lastError);
  throw lastError;
};
